import { render, staticRenderFns } from "./ReportsRegistrations.vue?vue&type=template&id=abb18044&scoped=true&"
import script from "./ReportsRegistrations.vue?vue&type=script&lang=ts&"
export * from "./ReportsRegistrations.vue?vue&type=script&lang=ts&"
import style0 from "./ReportsRegistrations.vue?vue&type=style&index=0&id=abb18044&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb18044",
  null
  
)

export default component.exports